export default {
      id: "notifications__maintenance-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.svg#notifications__maintenance",
      toString: function () {
        return this.url;
      }
    }